// import React, { useState } from "react";
// import { register } from "../services/authService";
// import { useNavigate } from "react-router-dom";

// export default function Register() {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");
//   const [message, setMessage] = useState("");
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       await register(username, password);
//       setMessage("Registration successful. Redirecting to login...");
//       setTimeout(()=> navigate("/login"), 1200);
//     } catch (err) {
//       setMessage(err.response?.data || "Registration failed");
//     }
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto">
//       <h2 className="text-2xl font-bold mb-4">Register</h2>
//       {message && <div className="mb-2">{message}</div>}
//       <form onSubmit={handleSubmit} className="flex flex-col gap-3">
//         <input required value={username} onChange={e=>setUsername(e.target.value)} placeholder="Username" className="border p-2 rounded"/>
//         <input required type="password" value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" className="border p-2 rounded"/>
//         <button className="bg-green-600 text-white p-2 rounded">Register</button>
//       </form>
//     </div>
//   );
// }


// import { useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function AdminLogin() {
//   const [u, setU] = useState("");
//   const [p, setP] = useState("");
//   const [msg, setMsg] = useState("");
//   const nav = useNavigate();

//   const submit = (e) => {
//     e.preventDefault();

//     if (u === "admin" && p === "admin123") {
//       localStorage.setItem("user", JSON.stringify({
//         id: 0, fullName: "Admin", email: "admin@hotel.com", role: "ADMIN"
//       }));
//       nav("/admin/manage-rooms");
//     } else {
//       setMsg("Invalid admin credentials");
//     }
//   };

//   return (
//     <div className="p-6 max-w-md mx-auto">
//       <h2 className="text-xl mb-4">Admin Login</h2>
//       {msg && <p className="text-red-600">{msg}</p>}

//       <form onSubmit={submit} className="flex flex-col gap-3">
//         <input className="border p-2" placeholder="Admin Username" onChange={(e) => setU(e.target.value)} />
//         <input className="border p-2" placeholder="Password" type="password" onChange={(e) => setP(e.target.value)} />
//         <button className="bg-gray-800 text-white p-2">Login</button>
//       </form>
//     </div>
//   );
// }

// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import AuthService from "../services/authService";

// export default function Register() {
//   const navigate = useNavigate();
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     password: "",
//   });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleRegister = (e) => {
//     e.preventDefault();

//     const result = AuthService.registerUser(form.name, form.email, form.password);

//     if (!result.success) {
//       alert(result.message);
//       return;
//     }

//     alert("Registration Successful!");
//     navigate("/login");
//   };

//   return (
//     <div className="login-container">
//       <form className="login-card" onSubmit={handleRegister}>
//         <h2>Create Account</h2>

//         <input
//           type="text"
//           name="name"
//           placeholder="Full Name"
//           value={form.name}
//           onChange={handleChange}
//           required
//         />

//         <input
//           type="email"
//           name="email"
//           placeholder="Email Address"
//           value={form.email}
//           onChange={handleChange}
//           required
//         />

//         <input
//           type="password"
//           name="password"
//           placeholder="Password"
//           value={form.password}
//           onChange={handleChange}
//           required
//         />

//         <button type="submit">Register</button>

//         <p>
//           Already have an account?{" "}
//           <span onClick={() => navigate("/login")}>Login</span>
//         </p>
//       </form>
//     </div>
//   );
// }


//*******REGISTER PAGE UI DESIGN 5/1/26******* */
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

export default function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRegister = async (e) => {
    e.preventDefault();

    if (form.phone.length !== 10) {
      alert("Phone number must be 10 digits");
      return;
    }

    try {
      await axios.post("http://localhost:8080/api/auth/signup", {
        username: form.name,
        email: form.email,
        phone: form.phone,
        password: form.password,
      });

      alert("Registration Successful!");
      navigate("/login");
    } catch (error) {
      console.error("Register Error:", error);
      alert(error.response?.data || "Registration failed");
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center vh-100">
      <div className="card shadow-lg border-0 p-4" style={{ width: "420px" }}>
        <h3 className="text-center fw-bold mb-2">📝 Create Account</h3>
        <p className="text-center text-muted mb-4">
          Register to start booking rooms
        </p>

        <form onSubmit={handleRegister}>
          <div className="mb-3">
            <label className="form-label fw-semibold">Full Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              placeholder="Enter full name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Email Address</label>
            <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Phone Number</label>
            <input
              type="tel"
              className="form-control"
              name="phone"
              placeholder="10 digit mobile number"
              value={form.phone}
              onChange={handleChange}
              maxLength="10"
              required
            />
          </div>

          <div className="mb-3">
            <label className="form-label fw-semibold">Password</label>
            <input
              type="password"
              className="form-control"
              name="password"
              placeholder="Create password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          <button className="btn btn-success w-100 fw-bold mt-2">
            Register
          </button>
        </form>

        <div className="text-center mt-3">
          <small>
            Already have an account?{" "}
            <Link to="/login" className="fw-semibold text-success">
              Login
            </Link>
          </small>
        </div>
      </div>
    </div>
  );
}
